import React from 'react';
// this component is used in components/pages/live/index.jsx
const ColorNote = (props) => {
    var descs;
    switch (props.mode) {
        case "sensors":
            descs = ["Occupied", "Standby", "Unoccupied", "Offline", "Maintenance"];
            break;

        case "heatmap":
            descs = ["Above average", "Average", "Below average"];
            break;

        default:

    }
    return (
        <table className="popup-color-note"><tbody>
            <tr>
                <td>
                    <span className="popup-color-note-td red">{descs[0]}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span className="popup-color-note-td yellow">{descs[1]}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span className="popup-color-note-td green">{descs[2]}</span>
                </td>
            </tr>
            {(props.mode == "sensors") &&
                <React.Fragment>
                    <tr><td></td></tr>
                    <tr>
                        <td>
                            <span className="popup-color-note-td blue">{descs[3]}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span className="popup-color-note-td brown">{descs[4]}</span>
                        </td>
                    </tr>
                </React.Fragment>}
        </tbody></table>
    );
}

export default ColorNote


// WEBPACK FOOTER //
// ./src/components/common/colornote.jsx